import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Upload as AntDUpload } from 'antd';
import { UploadProps } from 'antd/es/upload/Upload';
import styled from 'styled-components';

import DefaultItemRender from './UploadDefaultItemRender';

const StyledUpload = styled(AntDUpload)`
  color: var(--dark-blue);
  margin-left: 5px;
  font-size: 12px;
  cursor: pointer;
`;

const Upload = (props: UploadProps) => {
  const { itemRender = DefaultItemRender, ...restProps } = props;
  return (
    <StyledUpload {...restProps} itemRender={itemRender}>
      <PlusOutlined style={{ color: 'var(--dark-blue)', fontSize: 12, marginRight: '3px' }} />
      Upload Attachments
    </StyledUpload>
  );
};

export default Upload;
